export const hoursDay:hourDayType[] = [
    "00h",
    "01h",
    "02h",
    "03h",
    "04h",
    "05h",
    "06h",
    "07h",
    "08h",
    "09h",
    "10h",
    "11h",
    "12h",
    "13h",
    "14h",
    "15h",
    "16h",
    "17h",
    "18h",
    "19h",
    "20h",
    "21h",
    "22h",
    "23h",
]

export type hourDayType = "00h"|"01h"|"02h"|"03h"|"04h"|"05h"|"06h"|"07h"|"08h"|"09h"|"10h"|"11h"|"12h"|"13h"|"14h"|"15h"|"16h"|"17h"|"18h"|"19h"|"20h"|"21h"|"22h"|"23h"
